/**
 * env.ts
 * Purpose: Resolve frontend runtime config, including UAT API host alignment
 * Main flow: Read Vite env → rewrite known flaky origin hostnames → export
 * Key constraints: Prefer the public F5 XC API host (api.clientconverge) over the
 *   ALB origin hostname (uatapi) so browser CORS/auth stay on the edge domain.
 */

const UAT_ORIGIN_API_HOST = 'uatapi.presidio-client-converge.com'
const UAT_PUBLIC_API_HOST = 'api.clientconverge.psdoxclab.com'

function resolveApiUrl(raw: string): string {
  try {
    const url = new URL(raw)
    if (url.hostname === UAT_ORIGIN_API_HOST) {
      url.hostname = UAT_PUBLIC_API_HOST
    }
    const path = url.pathname.replace(/\/$/, '')
    return `${url.protocol}//${url.host}${path}${url.search}`
  } catch {
    return raw
  }
}

export const env = {
  API_URL: resolveApiUrl(import.meta.env.VITE_API_URL || 'http://localhost:8000/api'),
  API_VERSION: import.meta.env.VITE_API_VERSION || 'v1',
  APP_ENV: import.meta.env.VITE_APP_ENV || 'development',
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  ENABLE_DEBUG_MODE: import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  // AWS Cognito - Shared Pool
  AWS_REGION: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  AWS_USER_POOL_ID: import.meta.env.VITE_AWS_USER_POOL_ID || '',
  AWS_USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_AWS_USER_POOL_WEB_CLIENT_ID || '',
  AWS_COGNITO_DOMAIN: import.meta.env.VITE_AWS_COGNITO_DOMAIN || '',
  // Role Configuration
  ALLOWED_ROLES: (import.meta.env.VITE_ALLOWED_ROLES || '').split(',').map(role => role.trim()).filter(Boolean),
} as const

export const isDevelopment = env.APP_ENV === 'development'
export const isProduction = env.APP_ENV === 'production'
export const isTesting = env.APP_ENV === 'test'
